export default __webpack_public_path__ + "static/media/commodityYearBook2023.847ed2bf.pdf";